import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { RoomRow } from './templates/RoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const RemoteAirSensorRow = ({ manifold }: Props) => {
  return (
    <RoomRow
      name="Remote Air Sensor"
      manifold={manifold}
      getValue={room => (room.numberOfWetSensors === 0 ? 'No' : 'Yes')}
    />
  );
};
